import * as tslib_1 from "tslib";
import { uniq } from 'lodash';
export function mapLinksInput(params) {
    return {
        equipmentIds: extractEquipmentIds(params),
        locationSectorIds: extractSectorIds(params),
        locationEnvironmentIds: extractEnvironmentIds(params),
    };
}
export function extractSectorIds(params) {
    var e_1, _a, e_2, _b, e_3, _c;
    var locationSectors = params.locationSectors, locationEnvironments = params.locationEnvironments, newEquipments = params.newEquipments;
    var locationSectorIds = [];
    try {
        for (var _d = tslib_1.__values(locationSectors || []), _e = _d.next(); !_e.done; _e = _d.next()) {
            var locationSector = _e.value;
            locationSectorIds.push(locationSector.id);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _f = tslib_1.__values(locationEnvironments || []), _g = _f.next(); !_g.done; _g = _f.next()) {
            var locationEnvironment = _g.value;
            if (locationEnvironment.locationSector) {
                locationSectorIds.push(locationEnvironment.locationSector.id);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var _h = tslib_1.__values(newEquipments || []), _j = _h.next(); !_j.done; _j = _h.next()) {
            var equipment = _j.value;
            if (equipment.locationSector) {
                locationSectorIds.push(equipment.locationSector.id);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return uniq(locationSectorIds);
}
export function extractEnvironmentIds(params) {
    var e_4, _a, e_5, _b;
    var locationEnvironments = params.locationEnvironments, newEquipments = params.newEquipments;
    var locationEnvironmentIds = [];
    try {
        for (var _c = tslib_1.__values(locationEnvironments || []), _d = _c.next(); !_d.done; _d = _c.next()) {
            var locationEnvironment = _d.value;
            locationEnvironmentIds.push(locationEnvironment.id);
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_4) throw e_4.error; }
    }
    try {
        for (var _e = tslib_1.__values(newEquipments || []), _f = _e.next(); !_f.done; _f = _e.next()) {
            var equipment = _f.value;
            if (equipment.locationEnvironment) {
                locationEnvironmentIds.push(equipment.locationEnvironment.id);
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return uniq(locationEnvironmentIds);
}
export function extractEquipmentIds(params) {
    var e_6, _a, e_7, _b;
    var equipments = params.equipments, newEquipments = params.newEquipments;
    var equipmentIds = [];
    try {
        for (var _c = tslib_1.__values(equipments || []), _d = _c.next(); !_d.done; _d = _c.next()) {
            var equipmentId = _d.value;
            equipmentIds.push(equipmentId);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_6) throw e_6.error; }
    }
    try {
        for (var _e = tslib_1.__values(newEquipments || []), _f = _e.next(); !_f.done; _f = _e.next()) {
            var equipment = _f.value;
            equipmentIds.push(equipment.id);
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return uniq(equipmentIds);
}
